import React from 'react';

function SapInvoices() {
  return <div>SapInvoices</div>;
}

export default SapInvoices;
